import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminCatalogosSatPage } from "@/features/admin-catalogos-sat/components/AdminCatalogosSatPage";
import { clavesSatAdminQueryOptions } from "@/features/admin-catalogos-sat/hooks/use-claves-sat-admin";

/** Ruta `/admin/catalogos-sat` · CRUD del catálogo SAT. */
export const Route = createFileRoute("/_authed-tw/admin/catalogos-sat")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(clavesSatAdminQueryOptions({ page: 1, pageSize: 15 })),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminCatalogosSat]}>
      <AdminCatalogosSatPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
